module.exports = __webpack_public_path__ + "static/media/tickets.a4781609.svg";